import React, { Component } from 'react'
import { Bar } from 'react-chartjs-2';
import totol_posts_30_data from '../json/total_posts_30.json'

var array_keys = new Array();
var array_values = new Array();

for (var key in totol_posts_30_data) {
    array_keys.push(key);
    array_values.push(totol_posts_30_data[key]);
}

let colors = []
for(var i=0; i<30; i++) {
  colors.push('#'+Math.floor(Math.random()*16777215).toString(16));
}

const data = {
	labels: array_keys,
	datasets: [{
        label: '发帖数',
        data: array_values,
        backgroundColor: colors
    }],
};

export class TotalPostsChart extends Component {
    render() {
        return (
            <div>
                <Bar data={data} />
            </div>
        )
    }
}

export default TotalPostsChart  
